import { Button, Link, Typography } from '@material-ui/core'
import { OpenInNewWindowIcon } from 'components/icons'
import useStyles from './InsuranceVerificationFailed.styles'
import {
  HEALTH_CONTACT_EMAIL,
  PUMP_PARTS_STORE_PAGE_URL,
} from '../../../constants'

const InsuranceVerificationFailedV1 = () => {
  const classes = useStyles()
  return (
    <>
      <Typography
        className={classes.title}
        color="primary"
        component="h1"
        variant="h4"
      >
        The insurance plan used to purchase your pump is no longer active.
      </Typography>
      <Typography className={classes.body} color="primary" variant="body2">
        At this time, we're unable to update the insurance on file for
        replacement parts orders.
      </Typography>
      <Typography className={classes.body} color="primary" variant="body2">
        Still have questions or think there's been an error? Email{' '}
        <Link
          className={classes.emailLink}
          href={`mailto:${HEALTH_CONTACT_EMAIL}`}
        >
          {HEALTH_CONTACT_EMAIL}
        </Link>
        .
      </Typography>

      <Typography
        className={classes.subtitle}
        color="primary"
        component="h1"
        variant="h4"
      >
        Need parts now?
      </Typography>
      <Typography className={classes.body} color="primary" variant="body2">
        We should have what you need on the Babylist Shop.
      </Typography>

      <Button
        classes={{ root: classes.linkButton }}
        color="secondary"
        endIcon={<OpenInNewWindowIcon />}
        href={PUMP_PARTS_STORE_PAGE_URL}
        size="large"
        variant="contained"
      >
        Shop for Pump Parts
      </Button>
    </>
  )
}

export default InsuranceVerificationFailedV1
